import random from 'toxilibs/random.js'
import Level from '../core/level.js'
import mathText from '../math_text.js'

const level = new Level({
    name: 'distance_to_origin',
    dependencies: [
        'levels_maths/simple_length',
        'levels_maths/pythagorean_on_point',
        'levels_maths/pythagorean_with_root'
    ]
})


function common (q, params) {
    params = params || {}

    let a = {
        x: random.fairChoiceInt(1, 5, {name: 'x'}),
        y: random.fairChoiceInt(1, 5, {name: 'y'}),
        name: 'A',
        color: '#F00'
    }

    if (!params.noScreen) {
        let geoScreen = q.addGeoScreen()
        geoScreen.addPolygon({points: [{x: 0, y: 0}, a]})
    }


    let o = {
        name:  'O',
        color: '#226ea5'
    }

    q.addText(mathText.point(a))
    q.addText(mathText.pointsDistance(o, a) + ' ?')
    q.answer = [
        'racine(' + (a.x * a.x + a.y * a.y) + ')',
        q.approximation(Math.sqrt(a.x * a.x + a.y * a.y), 0.1)
    ]
}



level.addQuestion({
    generator: function (q) {
        common(q)
    },
    times: 2
})


level.addQuestion({
    generator: function (q) {
        common(q, {noScreen: true})
    }
})


export default level

